import React, {useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Profile.css';
import logo from './logo.png';
import logoVarita from './varita.svg'
import Usuario from '../supabase/Usuario'

export default function Profile() {
    const navigate = useNavigate();
    const { user, logout } = useAuth();

    const handleLogout = () => {
        logout();
        navigate('/');
    };
    const [usuario, setUsuario] = useState({
        nombre: '',
        correo: '',
        telefono: '',
        varitas: 0,
        calificacion: 0,
        historia: '',
        reseñas: [],
        tipo: 0
    });
    const [resennas, setResennas] = useState()

    useEffect(() => {
        async function fetchData() {
            const data = await Usuario.getUsuario(user.numDocumento)
            const data2 = await Usuario.getResennas(user.numDocumento)

            if (data && data.length > 0) {
                const u = data[0]; // Supabase RPC returns an array of rows
                setUsuario({
                    nombre: u.usuario || '',
                    correo: u.correo || '',
                    telefono: u.numtelefono || '',
                    varitas: u.cantvaritas || 0,
                    calificacion: u.calificacion || 0,
                    historia: u.descripcion || '',
                    reseñas: [],
                    tipo: u.idtipousuario || 1
                });
            }
            setResennas(data2)
        }
        fetchData()
    }, [user]);


    const renderStars = (n) =>
        '★★★★★☆☆☆☆☆'.slice(5 - n, 10 - n); //n: enteros 0-5
    if (usuario.tipo === 2){ //si es un admin
        return (
        <div className="app-container">
            <div className="profile-page">
                <header className="topbar" role="banner">
                    <div className="brand">
                        <img src={logo} alt="Logo reANIDArt - Muestra 1 pájaro con dos polluelos en un nido de ramas con hojas alrededor" className="brand-logo" />
                        <nav className="nav" aria-label="navegación principal">
                            <button className="nav-link" onClick={() => navigate('/home')}>Inicio</button>
                            <button className="nav-link active" onClick={() => navigate('/profile')}>Mi nido</button>
                        </nav>
                        <button className="logout-btn" onClick={handleLogout} title="Cerrar sesión" aria-label="Cerrar sesión">↪</button>
                    </div>
                    <title>ReANIDArt - Perfil admin</title>
                </header>
                {/* Main Profile */}
                <main className="profile" role="main">
                    {/* Profile Card */}
                    <div className="profile-card">
                        <div className="profile-info">
                            <div className="avatar">
                                {usuario.nombre}
                            </div>
                            <div className="profile-details">
                                <span className="username">{usuario.nombre}</span>
                                <div className="varitas">
                                    <span>{usuario.varitas}</span>
                                    <img src={logoVarita} alt="logo cantidad de varitas"/>
                                </div>
                            </div>
                        </div>
                        <span style={{ fontSize: '18px', opacity: 0.7 }}>🛡️</span>
                    </div>
                    <button className="btn" onClick={() => navigate("/profile/userView")}>Usuarios</button>
                    <button className="btn" onClick={() => navigate("/profile/reviewsView")}>Reseñas</button>
                </main>
            </div>
        </div>
        );
    }
    return (
        <div className="app-container">
            <div className="profile-page">
                <header className="topbar" role="banner">
                    <div className="brand">
                        <img src={logo} alt="Logo reANIDArt - Muestra 1 pájaro con dos polluelos en un nido de ramas con hojas alrededor" className="brand-logo" />
                        <nav className="nav" aria-label="navegación principal">
                            <button className="nav-link" onClick={() => navigate('/home')}>Inicio</button>
                            <button className="nav-link active" onClick={() => navigate('/profile')}>Mi nido</button>
                        </nav>
                        <button className="logout-btn" onClick={handleLogout} title="Cerrar sesión" aria-label="Cerrar sesión">↪</button>
                    </div>
                    <title>ReANIDArt - Perfil</title>
                </header>

                {/* Main Profile */}
                <main className="profile" role="main">
                    {/* Profile Card */}
                    <div className="profile-card">
                        <div className="profile-info">
                            <div className="avatar">
                                {usuario.nombre[0]}
                            </div>
                            <div className="profile-details">
                                <span className="username">{usuario.nombre}</span>
                                <div className="rating">
                                    <span className="rating-stars">{renderStars(usuario.calificacion)}</span>
                                </div>
                                <div className="varitas">
                                    <span>{usuario.varitas}</span>
                                    <img src={logoVarita} alt="logo cantidad de varitas"/>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Contact Info */}
                    <div className="contact-card">
                        <div className="contact-item">
                            <span style={{ fontSize: '18px', opacity: 1 }}>✉️</span>
                            {usuario.correo}
                        </div>
                        <div className="contact-item">
                            <span style={{ fontSize: '18px', opacity: 1 }}>📞</span>
                            {usuario.telefono}
                        </div>
                    </div>

                    {/* Story */}
                    <div className="story">
                        <h4>Mi historia:</h4>
                        <p>{usuario.historia}</p>
                    </div>

                    <div>
                        <button className="btn" onClick={() => navigate('/profile/edit')}>Editar perfil ✏️</button>
                    </div>
                    <div>
                        <button className="btn" onClick={() => navigate('/profile/history')}>Historial 🕒</button>
                    </div>

                    {/* Reviews */}
                    <div className="reviews">
                        <h4>Mis reseñas</h4>
                        {resennas && resennas.length > 0 ? (
                            resennas.map((r) => (
                                <div className="review-card" key={r.id}>
                                    <div className="product">{r.titulo}</div>
                                    <div className="stars">{renderStars(r.valoracion)}</div>
                                    <p>{r.descripcion}</p>
                                </div>
                            ))
                        ) : (
                            <p style={{ opacity: 0.7 }}>Aún no tienes reseñas.</p>
                        )}
                    </div>

                </main>
            </div>
        </div>
    );
}
